import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/documentTemplate/getters";
import { actions } from "@/store/modules/documentTemplate/actions";
import { mutations } from "@/store/modules/documentTemplate/mutations";
import {
  IDocumentTemplateState,
  state,
} from "@/store/modules/documentTemplate/state";

export const documentTemplate: Module<IDocumentTemplateState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
